import { useMemo } from 'react';

import { UseCreateResource, useCreateResource } from './useCreateResource';
import { UseUpdateResource, useUpdateResource } from './useUpdateResource';

export interface UseSaveResource extends UseCreateResource {
  id?: UseUpdateResource['id'];
}

export const useSaveResource = ({
  url,
  id,
  invalidateQueryKey,
  message
}: UseSaveResource) => {
  const create = useCreateResource({
    url,
    invalidateQueryKey,
    message
  });
  const update = useUpdateResource({
    url,
    id: id!,
    message,
    invalidateQueryKey
  });

  return useMemo(() => (id ? update : create), [id, update, create]);
};
